export default __webpack_public_path__ + "static/media/sf-with-invoice-off-platform.96cdf579.png";